import React, { useCallback } from "react";
import FilterInputPairs from "./filter-input-pairs";
import Details from "./details";
import type { FilterOption } from "components/types/filter-options";

type FilterFieldsetProps = {
  displayName: string;
  fieldsetHeader: string | null;
  filters?: string[];
  filterOpen: boolean;
  keyName: string;
  onToggleOpenFilters: (keyName: string, isOpen: boolean) => void;
  onChange: (filter: { filterGroupKey: string; name: string; selected: boolean }) => void;
  values: FilterOption["values"];
};

const FilterFieldset = ({
  displayName,
  fieldsetHeader,
  filters,
  filterOpen,
  keyName,
  onToggleOpenFilters,
  onChange,
  values,
}: FilterFieldsetProps) => {
  const onToggle = useCallback(() => {
    onToggleOpenFilters(keyName, !filterOpen);
  }, [keyName, filterOpen, onToggleOpenFilters]);

  return (
    <Details
      key={keyName}
      className={"filter-fieldset " + keyName}
      isOpen={filterOpen}
      onToggle={onToggle}
      title={fieldsetHeader ?? displayName}
      count={filters?.length || 0}>
      {filterOpen && <FilterInputPairs filters={filters} keyName={keyName} onChange={onChange} values={values} />}
    </Details>
  );
};

export default FilterFieldset;
